import React from "react";
import ReactTable from "react-table";
import Chart from "react-google-charts";
import { toast } from "react-toastify";
import "react-table/react-table.css";
import copysvg from "./../../assets/arrow_copy.svg";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function FacilitatorKRAGrid(props)
{
    const copyToClipboard = (content) => {
		const el = document.createElement('textarea');
		el.value = content;
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	  };

    var columns=[{
        Header: "Facilitator KRA Dashboard",
        columns: [
            {
                id: "reportType",
                Header: "",
                with:80,
                accessor: "reportType",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            borderLeft: 'solid 1px #ccc',	
                            borderRight:'solid 1px #ccc',				
                        },
                    };
                },
            },
            {
                id: "Title",
                Header: "",
                width:500,
                accessor: "Title",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            borderLeft: 'solid 1px #ccc',	
                            borderRight:'solid 1px #ccc',				
                        },
                    };
                },
            },
            {
                id: "target",
                Header: "Target",
                accessor: "target",
                width:200,
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            borderLeft: 'solid 1px #ccc',	
                            borderRight:'solid 1px #ccc',				
                        },
                    };
                },
            },
            {
                id: "actual",
                Header: "Actual",
                accessor: "actual",
                headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
                style: { 'whiteSpace': 'unset','fontWeight':'bold' },
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            borderLeft: 'solid 1px #ccc',	
                            borderRight:'solid 1px #ccc',				
                        },
                    };
                },
                width:250,
                Cell: ({ original }) =>(
                    original["key"]==="quality_analysis_fatal_count"?
                    (
                        <a
                            style={{ textDecoration: "underline" }}
                            title={`${
                                original.hasOwnProperty('service_instance_ids')&&
                                original['service_instance_ids'].toString().replace(/,/g, '\n')}${'\n'}${
                                original.hasOwnProperty('quality_analysis_fatal_details')&&
                                original['quality_analysis_fatal_details']}`}
                        >
                        {original["actual"]}
                        </a>
                    ):
                    original["key"]==="three_resourses_availed_users"?
                    (
                        <>
                            {
                                original["actual"]&&
                                (parseInt(original["actual"])>0)?
                                (
                                    <img
                                        alt="copy"
                                        src={copysvg}
                                        height={"20px"}
                                        width={"16px"}
                                        className="con-cursor-pointer conv-mr13"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            copyToClipboard(original.hasOwnProperty('three_resourses_availed_user_emails')&&
                                            original['three_resourses_availed_user_emails']);
                                            toast('Users Email Copied!', {
                                                autoClose: 5000,
                                                type: toast.TYPE.SUCCESS,
                                            });
                                        }}
                                    />
                                ):("")
                            }     

                            <a
                                style={{ textDecoration: "underline" }}
                                title={`${
                                original.hasOwnProperty('three_resourses_availed_user_emails')&&
                                original['three_resourses_availed_user_emails']}`}
                            >
                            {original["actual"]}
                        </a>
                        </>
                        
                    ):
                    original["key"]==="two_resourses_availed_users"?
                    (
                        <>
                            {
                                original["actual"]&&
                                (parseInt(original["actual"])>0)?
                                (
                                    <img
                                        alt="copy"
                                        src={copysvg}
                                        height={"20px"}
                                        width={"16px"}
                                        className="con-cursor-pointer conv-mr13"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            copyToClipboard(original.hasOwnProperty('two_resourses_availed_user_emails')&&
                                            original['two_resourses_availed_user_emails']);
                                            toast('Users Email Copied!', {
                                                autoClose: 5000,
                                                type: toast.TYPE.SUCCESS,
                                            });
                                        }}
                                    />
                                ):("")
                            }     

                            <a
                                style={{ textDecoration: "underline" }}
                                title={`${
                                original.hasOwnProperty('two_resourses_availed_user_emails')&&
                                original['two_resourses_availed_user_emails']}`}
                            >
                            {original["actual"]}
                        </a>
                        </>
                        
                    )
                    :
                    original["key"]==="delivered_targeted_vs_achieved"||original["key"]==="three_plus_targeted_vs_achieved"?
                    (

                        <Chart
                            width={'220px'}
                            height={'100px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                original.hasOwnProperty('graph_target')&&
                                original['graph_target']||0, 
                                original.hasOwnProperty('achieved')&&
                                original['achieved']]||0,
                            ]}
                            options={{
                                title: '',
                                chartArea: { left:10,width: '55%'},
                                hAxis: {
                                title: '',
                                minValue: 0,
                                },
                                vAxis: {
                                title: '',
                                },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                    ):
                    original["key"]==="targeted_vs_achieved"?
                    (
                        <Chart
                            width={'150px'}
                            height={'100px'}
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={[
                                ['Performance', 'Target', 'Achieved'],
                                ['', 
                                original.hasOwnProperty('handle_target')&&
                                original['handle_target']||0, 
                                original.hasOwnProperty('achieved')&&
                                original['achieved']]||0,
                            ]}
                            options={{
                                title: '',
                                chartArea: { width: '100px' },
                                hAxis: {
                                title: '',
                                minValue: 0,
                                },
                                vAxis: {
                                title: '',
                                },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '1' }}
                            />
                    )
                    :
                    original["key"]==="assigned_customers"?
                    (
                        <>
                        {original["actual"]}

                            <span
                                style={{ "textDecoration": "underline","color":"blue",marginLeft:"5px" }} 
                                onClick={() =>props.fetchFacilitatorCallReport()}
                            >
                                Introductory Call Report                            
                            </span>
                        </>
                        
                    )
                    :
                    (
                        original["actual"]
                    )
                )
				,
            },
        ]
    }];

    return (
        <ReactTableFixedColumns
            data={props.data || []}
            columns={columns}
            sortable={false}
            showPagination={false}
            pageSize={20}
            style={{overflowY: "auto",height: "520px"}}	
            className="-striped"
        />
    );
}